import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface PaymentStatusBadgeProps {
  status: string;
  className?: string;
}

export function PaymentStatusBadge({ status, className }: PaymentStatusBadgeProps) {
  const getStatusConfig = (status: string) => {
    switch (status.toLowerCase()) {
      case 'completed':
        return { label: 'Completed', variant: 'success' };
      case 'pending':
        return { label: 'Pending', variant: 'warning' };
      case 'processing':
        return { label: 'Processing', variant: 'info' };
      case 'failed':
        return { label: 'Failed', variant: 'destructive' };
      case 'refunded':
        return { label: 'Refunded', variant: 'secondary' };
      case 'rejected':
        return { label: 'Rejected', variant: 'destructive' };
      default:
        return { label: status, variant: 'default' };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Badge
      variant={config.variant as any}
      className={cn("capitalize", className)}
    >
      {config.label}
    </Badge>
  );
}